// FitClutch — funil web — textos em alemão
export default {
  'ageSelect.titleLine1': 'Erstelle deinen',
  'ageSelect.titleHighlight': 'Personalisierten Trainingsplan',
  'ageSelect.poweredBy': 'Unterstützt durch FitClutch AI',
  'ageSelect.subtitle': 'Wähle deine Altersgruppe, um loszulegen',
  'ageSelect.duration': '3-Minuten-Quiz',
  'ageSelect.ageLabel': 'Alter: {range}',
  'ageSelect.footnote': 'Mit dem Fortfahren stimmst du unseren {terms} und unserer {privacy} zu.',
  'ageSelect.termsLink': 'Nutzungsbedingungen',
  'ageSelect.privacyLink': 'Datenschutzrichtlinie',

  'gender.title': 'Was ist dein Geschlecht?',
  'gender.subtitle': 'Wir nutzen das nur, um deinen Plan zu personalisieren',
  'gender.male': 'Männlich',
  'gender.female': 'Weiblich',
  'gender.other': 'Keine Angabe',

  'socialProof.genderWomen': 'Frauen',
  'socialProof.genderMen': 'Männer',
  'socialProof.genderPeople': 'Menschen',
  'socialProof.decade20': 'in ihren Zwanzigern',
  'socialProof.decade30': 'in ihren Dreißigern',
  'socialProof.decade40': 'in ihren Vierzigern',
  'socialProof.decade50': 'in ihren Fünfzigern oder älter',
  'socialProof.headlineBig': 'Über {users} {gender}',
  'socialProof.subcopy': '{decade} vertrauen bereits auf FitClutch, um <hl>ihre Ziele passend zu ihrem Fitnesslevel und ihrer verfügbaren Ausrüstung</hl> zu erreichen. Es passt sich an, während du dich weiterentwickelst.',
  'socialProof.subcopyNoDecade': 'vertrauen bereits auf FitClutch, um <hl>ihre Ziele passend zu ihrem Fitnesslevel und ihrer verfügbaren Ausrüstung</hl> zu erreichen. Es passt sich an, während du dich weiterentwickelst.',
  'socialProof.downloadsLabel': 'Downloads',
  'socialProof.cta': 'Weiter',

  'goal.question': 'Was ist dein wichtigstes Fitnessziel?',
  'goal.option_hipertrofia': 'Muskeln aufbauen',
  'goal.option_emagrecer': 'Abnehmen',
  'goal.option_forca': 'Stärker werden',
  'goal.option_condicionamento': 'Allgemeine Fitness verbessern',
  'goal.feedbackLead': 'Perfekt:',
  'goal.feedback_hipertrofia': 'individuelle Kraftsessions mit videogeführter Technik bei jeder Wiederholung.',
  'goal.feedback_emagrecer': 'ein Trainingsplan, der deinen Stoffwechsel aktiv hält.',
  'goal.feedback_forca': 'sichere Lastprogression, um wirklich stärker zu werden.',
  'goal.feedback_condicionamento': 'ausgewogene Einheiten für mehr Ausdauer, Beweglichkeit und Energie.',

  'bodyShape.question': 'Was beschreibt deinen Körper heute am besten?',
  'bodyShape.option_magro_male': 'Schlank',
  'bodyShape.option_magro_female': 'Schlank',
  'bodyShape.option_magro_neutral': 'Schlanker Körper',
  'bodyShape.option_cheio_male': 'Vollere Figur',
  'bodyShape.option_cheio_female': 'Vollere Figur',
  'bodyShape.option_cheio_neutral': 'Vollere Figur',
  'bodyShape.option_atletico_male': 'Athletisch',
  'bodyShape.option_atletico_female': 'Athletisch',
  'bodyShape.option_atletico_neutral': 'Athletischer Körper',
  'bodyShape.option_definido_male': 'Definiert',
  'bodyShape.option_definido_female': 'Definiert',
  'bodyShape.option_definido_neutral': 'Definierter Körper',
  'bodyShape.option_medio_male': 'Durchschnittlich',
  'bodyShape.option_medio_female': 'Durchschnittlich',
  'bodyShape.option_medio_neutral': 'Durchschnittlicher Körper',

  'bodyGoal.question': 'Welchen Körper möchtest du erreichen?',
  'bodyGoal.option_definido_male': 'Definiert und straff',
  'bodyGoal.option_definido_female': 'Definiert und straff',
  'bodyGoal.option_definido_neutral': 'Definierter, straffer Körper',
  'bodyGoal.option_atletico_male': 'Athletisch und muskulös',
  'bodyGoal.option_atletico_female': 'Athletisch und fit',
  'bodyGoal.option_atletico_neutral': 'Athletischer, muskulöser Körper',
  'bodyGoal.option_magro_male': 'Schlank und leicht',
  'bodyGoal.option_magro_female': 'Schlank und leicht',
  'bodyGoal.option_magro_neutral': 'Schlanker, leichter Körper',
  'bodyGoal.option_curvilineo_male': 'Stark und kräftig',
  'bodyGoal.option_curvilineo_female': 'Stark und kurvig',
  'bodyGoal.option_curvilineo_neutral': 'Starker, definierter Körper',

  'lastBest.question': 'Wann hast du dich zuletzt körperlich am besten gefühlt?',
  'lastBest.option_agora': 'Gerade jetzt',
  'lastBest.option_menos_1_ano': 'Vor weniger als einem Jahr',
  'lastBest.option_1_3_anos': 'Vor 1–3 Jahren',
  'lastBest.option_mais_3_anos': 'Vor mehr als 3 Jahren',
  'lastBest.option_nunca': 'Nie',

  'weightTrend.question': 'Wie verändert sich dein Gewicht normalerweise?',
  'weightTrend.option_estavel': 'Ziemlich stabil',
  'weightTrend.option_varia': 'Schwankt je nach meinen Gewohnheiten',
  'weightTrend.option_subindo': 'Steigt stetig',
  'weightTrend.option_caindo': 'Sinkt stetig',
  'weightTrend.option_nao_sei': 'Nicht sicher',

  'transformPromo.headline': 'Dein Ziel: {target}. Wir zeigen dir genau, wie du dorthin kommst.',
  'transformPromo.subcopyLead': 'Trainiere sicher an deinen Grenzen. FitClutch bietet',
  'transformPromo.subcopyHighlight1': 'Video-Anleitungen von Experten',
  'transformPromo.subcopyMid': 'für jede Übung, damit du die richtige Technik triffst und',
  'transformPromo.subcopyHighlight2': 'Verletzungen vermeidest',
  'transformPromo.cta': 'Weiter',

  'pushUps.question': 'Wie viele Liegestütze schaffst du maximal am Stück?',
  'pushUps.option_nenhuma': 'Noch keine',
  'pushUps.option_1_5': '1-5',
  'pushUps.option_6_15': '6-15',
  'pushUps.option_16_30': '16-30',
  'pushUps.option_30_mais': 'Mehr als 30',

  'squats.question': 'Wie viele Kniebeugen schaffst du am Stück?',
  'squats.option_nenhuma': 'Noch keine',
  'squats.option_1_10': '1-10',
  'squats.option_11_25': '11-25',
  'squats.option_26_50': '26-50',
  'squats.option_50_mais': 'Mehr als 50',

  'flexibility.question': 'Wie beweglich bist du?',
  'flexibility.option_nao_alcanco': 'Komme nicht an meine Zehen',
  'flexibility.option_quase': 'Komme fast an meine Zehen',
  'flexibility.option_facil': 'Erreiche meine Zehen mühelos',
  'flexibility.option_muito_flexivel': 'Sehr beweglich (Spagat, tiefe Dehnungen)',
  'flexibility.option_nao_sei': 'Weiß ich nicht',

  'progressPromo.headline': 'Dein Ausgangspunkt steht fest. Jetzt sehen wir ihn sich bewegen.',
  'progressPromo.subcopyLead': 'Jedes Training wird',
  'progressPromo.subcopyHighlight': 'automatisch erfasst',
  'progressPromo.subcopyTail': '— Echtzeit-Statistiken, die dich motivieren.',
  'progressPromo.cta': 'Weiter',

  'focusArea.question': 'Was sind deine Zielzonen?',
  'focusArea.subtitle': 'Wähle eine bestimmte Zone oder "Ganzer Körper".',
  'focusArea.option_superior': 'Oberkörper',
  'focusArea.option_core': 'Core / Bauch',
  'focusArea.option_inferior': 'Unterkörper',
  'focusArea.option_corpo_inteiro': 'Ganzer Körper',
  'focusArea.cta': 'Weiter',

  'injuries.question': 'Gibt es einen Bereich, der mehr Vorsicht braucht?',
  'injuries.subtitle': 'Wir passen deine Übungen an, um diese Bereiche zu schonen.',
  'injuries.option_ombros': 'Schultern',
  'injuries.option_joelhos': 'Knie',
  'injuries.option_costas': 'Rücken',
  'injuries.option_nenhuma': 'Keiner',
  'injuries.disclaimer': 'Vorsorgliche Anpassungen — ersetzen keine ärztliche Untersuchung.',
  'injuries.cta': 'Weiter',

  'workoutDuration.question': 'Was ist deine ideale Trainingsdauer?',
  'workoutDuration.option_rapido': 'Schnell',
  'workoutDuration.option_rapido_subtitle': '3 Übungen',
  'workoutDuration.option_rapido_badge': 'Bis zu 20 Min',
  'workoutDuration.option_curto': 'Kurz',
  'workoutDuration.option_curto_subtitle': '4-6 Übungen',
  'workoutDuration.option_curto_badge': '20-40 Min',
  'workoutDuration.option_medio': 'Mittel',
  'workoutDuration.option_medio_subtitle': '5-7 Übungen',
  'workoutDuration.option_medio_badge': '40-60 Min',
  'workoutDuration.option_longo': 'Lang',
  'workoutDuration.option_longo_subtitle': '8-10 Übungen',
  'workoutDuration.option_longo_badge': '60+ Min',

  'trainingSummaryPromo.headline': '{days}, Einheiten von {duration} — kommen gleich.',
  'trainingSummaryPromo.subcopyLead': 'Direkt aus unserer',
  'trainingSummaryPromo.subcopyHighlight': 'Trainings-Bibliothek',
  'trainingSummaryPromo.subcopyTail': ' — es ist immer eins für dich bereit.',
  'trainingSummaryPromo.cta': 'Weiter',
  'trainingSummaryPromo.days_2': '1-2x pro Woche',
  'trainingSummaryPromo.days_4': '3-4x pro Woche',
  'trainingSummaryPromo.days_6': '5-6x pro Woche',
  'trainingSummaryPromo.days_7': 'Jeden Tag',

  'workSchedule.question': 'Wie sieht dein Arbeitsalltag aus?',
  'workSchedule.option_fixo': 'Bürozeiten',
  'workSchedule.option_noturno': 'Nachtschicht',
  'workSchedule.option_flexivel': 'Flexible Zeiten',
  'workSchedule.option_parado': 'Ich arbeite nicht',

  'dailyActivity.question': 'Wie aktiv ist dein Alltag?',
  'dailyActivity.option_sentado': 'Meistens sitzend',
  'dailyActivity.option_ativo': 'Meistens stehend oder in Bewegung',
  'dailyActivity.option_misto': 'Eine Mischung aus beidem',
  'dailyActivity.option_nao_sei': 'Bin mir nicht sicher',

  'sleepHours.question': 'Wie viel Schlaf bekommst du normalerweise?',
  'sleepHours.option_menos_5': 'Weniger als 5 Stunden',
  'sleepHours.option_5_6': '5-6 Stunden',
  'sleepHours.option_7_8': '7-8 Stunden',
  'sleepHours.option_mais_8': 'Mehr als 8 Stunden',

  'waterIntake.question': 'Wie viele Gläser Wasser trinkst du am Tag?',
  'waterIntake.subtitle': 'Tippe auf die Zahl, die deiner Routine am nächsten kommt.',
  'waterIntake.cta': 'Weiter',

  'profileSummary.headline': 'Hier ist dein Profil',
  'profileSummary.imcLabel': 'BMI - {imc}',
  'profileSummary.imcAbaixo': 'Unter',
  'profileSummary.imcNormal': 'Normal',
  'profileSummary.imcAcima': 'Über',
  'profileSummary.imcObeso': 'Adipös',
  'profileSummary.bodyTypeLabel': 'Körpertyp',
  'profileSummary.bodyType_ectomorfo': 'Ektomorph',
  'profileSummary.bodyType_mesomorfo': 'Mesomorph',
  'profileSummary.bodyType_endomorfo': 'Endomorph',
  'profileSummary.lifestyleLabel': 'Lebensstil',
  'profileSummary.lifestyle_sedentario': 'Sitzend',
  'profileSummary.lifestyle_ativo': 'Aktiv',
  'profileSummary.lifestyle_equilibrado': 'Ausgewogen',
  'profileSummary.conditioningLabel': 'Fitnesslevel',
  'profileSummary.conditioning_iniciante': 'Grundlegend',
  'profileSummary.conditioning_intermediario': 'Mittel',
  'profileSummary.conditioning_avancado': 'Fortgeschritten',
  'profileSummary.conditioning_especialista': 'Experte',
  'profileSummary.metabolismLabel': 'Stoffwechsel',
  'profileSummary.metabolism_lento': 'Langsam, nimmt leicht zu',
  'profileSummary.metabolism_acelerado': 'Schnell, nimmt leicht ab',
  'profileSummary.metabolism_equilibrado': 'Ausgewogen',
  'profileSummary.metabolism_variavel': 'Variabel, abhängig von Gewohnheiten',
  'profileSummary.cta': 'Weiter',

  'barriers.question': 'Was hat dich bisher davon abgehalten, fit zu werden?',
  'barriers.option_motivacao': 'Wenig Motivation',
  'barriers.option_sem_plano': 'Kein strukturierter Plan',
  'barriers.option_tempo': 'Zeitmangel',
  'barriers.option_lesoes': 'Körperliche Verletzungen',
  'barriers.option_outro': 'Andere Gründe',

  'consistencyChart.headline': 'FitClutch hilft dir, dranzubleiben!',
  'consistencyChart.subcopyLead': 'Dein persönlicher Plan hat alles, was du brauchst, um',
  'consistencyChart.subcopyHighlight1': 'deine Motivation hochzuhalten',
  'consistencyChart.subcopyMid': 'und',
  'consistencyChart.subcopyHighlight2': 'den Körper zu erreichen, den du willst',
  'consistencyChart.chartTitle': 'Deine Entwicklung',
  'consistencyChart.nowLabel': 'Jetzt',
  'consistencyChart.withLabel': 'Mit FitClutch',
  'consistencyChart.withoutLabel': 'Ohne FitClutch',
  'consistencyChart.disclaimer': 'Hinweis: Die Beispiele sind illustrativ. Konstanz bei Training und Ernährung ist es, was wirklich zum Ergebnis führt.',
  'consistencyChart.cta': 'Weiter',

  'progressLoader.headline': 'Dein persönlicher Trainingsplan wird erstellt',
  'progressLoader.item_bodyType': 'Anpassung an deinen Körpertyp und Alltag',
  'progressLoader.item_fitnessLevel': 'Bewertung deines Fitnesslevels',
  'progressLoader.item_plan': 'Erstellung deines persönlichen Plans',
  'progressLoader.testimonial1_title': 'Hat meinen Alltag verändert',
  'progressLoader.testimonial1_body': 'Endlich ein Plan, der wirklich zu meiner Woche passt. Leicht umzusetzen und die Trainings machen Sinn.',
  'progressLoader.testimonial1_author': 'Renata A.',
  'progressLoader.testimonial2_title': 'Echte Ergebnisse',
  'progressLoader.testimonial2_body': 'Schon nach wenigen Wochen habe ich den Unterschied bei Energie und Kraft gespürt. Der Plan passt sich mir an.',
  'progressLoader.testimonial2_author': 'Juliana M.',
  'progressLoader.testimonial3_title': 'Eine Routine, die ich wirklich durchziehe',
  'progressLoader.testimonial3_body': 'Vor FitClutch habe ich nie eine Routine durchgehalten. Jetzt gehört sie einfach zu meinem Tag.',
  'progressLoader.testimonial3_author': 'Carla S.',
  'progressLoader.testimonial4_title': 'Lohnt sich wirklich',
  'progressLoader.testimonial4_body': 'Einfach, auf den Punkt und wirklich auf meinen Körper und meinen Alltag zugeschnitten.',
  'progressLoader.testimonial4_author': 'Fernanda O.',

  'emailCapture.headlineLead': 'Gib deine E-Mail ein, um deinen',
  'emailCapture.headlineHighlight': 'Persönlichen Trainingsplan',
  'emailCapture.placeholder': 'deineemail@beispiel.com',
  'emailCapture.cta': 'Weiter',
  'emailCapture.privacyLead': 'Wir respektieren deine Privatsphäre und schützen deine persönlichen Daten gemäß unserer',
  'emailCapture.privacyLink': 'Datenschutzrichtlinie',
};
